import React from "react"
import { useHistory } from "react-router-dom"
import ReactPlayer from "react-player"
import { isVideo, getLaunchTime, redirectToOmnicuris, getCompletedTime } from "../utilities"
import { useDispatch, useSelector } from "react-redux"
import ExpertsList from "./ExpertsList"
import { INITIATE_AUTH_DRAWER } from "../actions/types"
import { isAuthenticated } from "../utilities"

function Cards(props) {
  const { data, courseId, courseSlug, platformType, sequence } = props
  const { domainDetails } = useSelector((state) => state.listings)
  const history = useHistory()
  const dispatch = useDispatch()

  const redirectTo = (ev) => {
    ev.stopPropagation()
    if (!isAuthenticated() && window.self === window.top) {
      dispatch({
        type: INITIATE_AUTH_DRAWER,
      })
    } else {
      //   if (domainDetails && domainDetails.orgType === 'certifier') {
      //     if (data.completed) {
      //       if (platformType === 'CME') {
      //       redirectToOmnicuris(`/academics/${courseSlug}/${data.seriesId}/${data.id}`,window.self != window.top);
      //     } else {
      //       redirectToOmnicuris(`/oc-originals/${courseSlug}/${data.seriesId}/${data.id}`,window.self != window.top);
      //     }
      //   } else {
      //     redirectToOmnicuris(`/oc-live/${data.id}`,window.self != window.top);
      //   }
      // } else {
      if (data.completed) {
        history.push(`/academics/${courseSlug}/${data.seriesId}/${data.id}`)
      } else {
        history.push(`/live/${data.id}`)
      }
      // }
    }
  }

  const config = {
    file: {
      attributes: {
        controlsList: "nofullscreen",
      },
    },
  }

  return (
    <div className="webinarsCards" onClick={redirectTo}>
      <div className="webinarsCardsNumber">{sequence}</div>
      <div className="webinarsDetails">
        <div className="webinarsMedia">
          {isVideo(data.webinarWebBannerUrl ? data.webinarWebBannerUrl : data.webinarAppBannerUrl) ? (
            <ReactPlayer url={data.webinarWebBannerUrl ? data.webinarWebBannerUrl : data.webinarAppBannerUrl} playing={false} controls={false} muted={true} config={config} playsinline={true} width={"100%"} height={"100%"} />
          ) : (
            <figure>
              <img src={window.innerWidth <= 768 ? data.webinarAppBannerUrl : data.webinarWebBannerUrl ? data.webinarWebBannerUrl : data.webinarAppBannerUrl} alt="" />
            </figure>
          )}
          <div className={`tags ${data.completed ? "tagsGreen" : "tagsOrange"}`}>{data.completed ? "Completed" : "Upcoming"}</div>
        </div>
        <div className="webinarsCardsFooter">
          {data.experts.length > 0 && <ExpertsList experts={data.experts} limit={2} />}
          <div className="webinarsLaunchDate">{data.completed ? getCompletedTime(data.launchTime) : getLaunchTime(data.launchTime)}</div>
        </div>
      </div>
    </div>
  )
}

export default Cards
